
import { application } from 'redevConfig'

const list = (application && application.list) || ''
const add = (application && application.add) || ''

const listPage = list ? require(`redevelopment/outputManage/application/${list.templateName}`) : require('./views/list.html')
const addPage = add ? require(`redevelopment/outputManage/application/${add.templateName}`) : require('./views/add.html')


export default {
    base: {
        state: 'outputManage.stock.application',
        config: {
            url: '/application',
            abstract: true,
            template: '<div ui-view></div>',
            title: '发票申领',
            default: 'outputManage.stock.application.list',
        },
    },
    list: {
        state: 'outputManage.stock.application.list',
        config: {
            url: '/list',
            template: listPage,
            controller: 'applicationListCtrl',
        },
    },
    application: {
        state: 'outputManage.stock.application.add',
        config: {
            url: '/add',
            template: addPage,
            controller: 'applicationAddCtrl',
            title: '网上申领',
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/application/routers.js